/**
 * Analytics event name constants.
 * Use these instead of raw strings to prevent typos and enable autocomplete.
 */

// Booking funnel
export const BOOKING_STARTED = "booking_started";
export const BOOKING_STEP_VIEWED = "booking_step_viewed";
export const BOOKING_STEP_COMPLETED = "booking_step_completed";
export const BOOKING_QUESTION_ANSWERED = "booking_question_answered";
export const BOOKING_ADDRESS_SELECTED = "booking_address_selected";
export const BOOKING_DATETIME_SELECTED = "booking_datetime_selected";
export const BOOKING_ESTIMATE_VIEWED = "booking_estimate_viewed";
export const BOOKING_PAYMENT_METHOD_ADDED = "booking_payment_method_added";
export const BOOKING_SUBMITTED = "booking_submitted";
export const BOOKING_CONFIRMED = "booking_confirmed";
export const BOOKING_ABANDONED = "booking_abandoned";
export const BOOKING_PROGRESS_RESTORED = "booking_progress_restored";

// Authentication
export const SIGNUP_STARTED = "signup_started";
export const SIGNUP_COMPLETED = "signup_completed";
export const LOGIN_COMPLETED = "login_completed";
export const LOGIN_FAILED = "login_failed";
export const LOGOUT = "logout";
export const PASSWORD_RESET_REQUESTED = "password_reset_requested";
export const PASSWORD_RESET_COMPLETED = "password_reset_completed";
export const OAUTH_INITIATED = "oauth_initiated";
export const EMAIL_VERIFIED = "email_verified";
export const PHONE_VERIFIED = "phone_verified";

// Post-booking (homeowner)
export const BOOKING_CANCELLED = "booking_cancelled";
export const BOOKING_RESCHEDULED = "booking_rescheduled";
export const BOOKING_REVIEWED = "booking_reviewed";

// Provider
export const PROVIDER_ONBOARDING_STARTED = "provider_onboarding_started";
export const PROVIDER_ONBOARDING_COMPLETED = "provider_onboarding_completed";
export const REQUEST_VIEWED = "request_viewed";
export const REQUEST_ACCEPTED = "request_accepted";
export const REQUEST_DECLINED = "request_declined";
export const JOB_COMPLETED = "job_completed";

// Errors
export const ERROR_DISPLAYED = "error_displayed";
export const ESTIMATE_FETCH_FAILED = "estimate_fetch_failed";
export const PAYMENT_FAILED = "payment_failed";
export const BOOKING_SUBMISSION_FAILED = "booking_submission_failed";

// Navigation
export const PAGE_VIEWED = "page_viewed";

// Engagement
export const SERVICE_CATEGORY_CLICKED = "service_category_clicked";
export const CTA_CLICKED = "cta_clicked";
export const SERVICE_SEARCHED = "service_searched";
export const SEARCH_RESULT_SELECTED = "search_result_selected";
